export const base64UrlEncode = (str: string) => {
  const bytes = new TextEncoder().encode(str);
  // Use Array.from to ensure correct argument type for String.fromCharCode
  const bin = String.fromCharCode(...Array.from(bytes));
  return btoa(bin).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};

const base64UrlToBase64 = (input: string) => {
  let b64 = input.replace(/-/g, "+").replace(/_/g, "/");
  const pad = b64.length % 4;
  if (pad) b64 += "=".repeat(4 - pad);
  return b64;
};

export const base64UrlDecode = <T = unknown>(base64url: string): T => {
  // Convert base64url back to standard base64
  const base64 = atob(base64UrlToBase64(base64url));

  // Parse JSON
  return JSON.parse(base64);
};
